import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import FailureCard from './components/Cards/FailureCard';
import { DefaultTheme } from '@material-ui/styles';
import { MemoryRouter } from 'react-router-dom';
import { isValidJWT } from './components/Auth/JWTAuth';
import { standaloneTheme } from './theme/standaloneTheme';

// Vite emits the bundle as a module script, where document.currentScript is not
// reliable. import.meta.url points at the current module URL in both dev and
// production builds.
// Derive the base URL from the script that loaded us. document.currentScript is
// available in classic scripts; import.meta.url is available in ES modules.
const _mfBaseUrl: string = (() => {
  try {
    if (typeof document !== 'undefined' && document.currentScript) {
      return `${new URL((document.currentScript as HTMLScriptElement).src).origin}/`;
    }
  } catch { /* fall through */ }
  return `${window.location.origin}/`;
})();
 

function loadEnvJs(): Promise<void> {
  return new Promise((resolve) => {
    const envUrl = `${_mfBaseUrl}env.js`;
    // Avoid loading the same script twice
    if (document.querySelector<HTMLScriptElement>(`script[src="${envUrl}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = envUrl;
    script.onload = () => resolve();
    script.onerror = () => {
      console.warn('[Env] Could not load env.js from', envUrl);
      resolve(); // don't block rendering
    };
    document.head.appendChild(script);
  });
}

export type MicroFrontendContract = {
  containerId: string;
  theme: DefaultTheme;
  token: string;
  initialPath?: string;
  parameters: {
    descriptor?: any;
  };
};

declare global {
  interface Window {
    renderQualityDataProductCard: (params: MicroFrontendContract) => void;
    unmountQualityDataProductCard: (containerId: string) => void;
  }
}

function renderToContainer(containerId: string, content: React.ReactNode, initialPath: string = '/') {
  ReactDOM.render(
    <React.StrictMode>
      <MemoryRouter initialEntries={[initialPath]}>{content}</MemoryRouter>
    </React.StrictMode>,
    document.getElementById(containerId),
  );
}

window.renderQualityDataProductCard = async (params) => {
  console.log("[Render] Rendering Card");
  console.log("[Render] Parameters:", params);
  console.log('[Render] initialPath: ' + (window.location.pathname + window.location.search));

  await loadEnvJs();

  const validToken = await isValidJWT(params.token);

  if (!validToken) {
    console.error("[Render] Invalid JWT token provided");
    renderToContainer(params.containerId, <FailureCard />);
  } else {
    console.log("[Render] Valid JWT token provided");
    const initialPath = window.location.pathname ?? '/';
    const descriptor = params.parameters?.descriptor;
    renderToContainer(
      params.containerId,
      <App
        theme={params.theme ?? standaloneTheme}
        descriptor={descriptor}
        token={params.token}
        initialPath={initialPath}
      />,
      initialPath,
    );
  }
};

window.unmountQualityDataProductCard = (containerId) => {
  console.log("[Unmount] Unmounting Card");
  const el = document.getElementById(containerId);
  if (el) {
    ReactDOM.unmountComponentAtNode(el);
  }
};
